import Icon from "../components/ui/Icon";

export const getTableColumns = () => {
    let tableColumns = [
        {header: "Name", field: "name"},
        {header: "Phone", field: "phone"},
        {header: "Email", field: "email"},
        {header: "Subject", field: "subject"},
        {header: "Message", field: "message"},
        {header: "", field: "status"},
    ];

    return tableColumns;
};


export const getTableData = ({items = []}) => {
    if (!Array.isArray(items)) return [];

    return items.map((item) => ({
        id: item.id ?? "N/A",
        name: item.name || "N/A",
        phone: item.phone || "N/A",
        email: item.email || "N/A",
        subject: (
            <div
                className={`text-truncate ${item.status === 0 ? "notVisited" : ""}`}
            >
                {item.subject || "N/A"}
            </div>
        ),
        message: (
            <div className="text-truncate">
                {item.message || "N/A"}
            </div>
        ),
        status: (
            item.status === 0
                ? <a className="btn border border-primary rounded-pill p-2" href={`contact/${item.id}`} onClick={(e) => e.stopPropagation()}><Icon name="unread_chat" width={20}/></a>
                : <a className="btn border rounded-pill p-2" href={`contact/${item.id}`} onClick={(e) => e.stopPropagation()}><Icon name="read_chat" width={20}/></a>
        ),
    }));
};

export const getDetailData = ({item}) => {
    if (!item) return {details: {}};
    return {
        details: {
            Id: item.id,
            name: item?.name,
            phone: item?.phone,
            email: item?.email,
            subject: item?.subject,
            message: item?.message,
        },
    };
};

